export default "__VITE_ASSET__klBnsCWd__"